import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTIONS]: {
		url:'/company/:companyId/done_works/:doneWorkId/finance_attribution/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/finance_attribution/:financeAttributionId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/finance_attribution/:financeAttributionId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].GET_DONE_WORKS_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/done_works/:doneWorkId/finance_attribution/:financeAttributionId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].CREATE_DONE_WORKS_FINANCE_ATTRIBUTION]: {
		url:'/company/:companyId/done_works/:doneWorkId/finance_attribution/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PATCH_DONE_WORKS_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/done_works/:doneWorkId/finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].PUT_DONE_WORKS_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/done_works/:doneWorkId/finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION].DELETE_DONE_WORKS_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/done_works/:doneWorkId/finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}